<template>
  <div class="firstpage" @click="close()" :style="showLz ? 'background:#00000080' : ''">
    <CarListNavbarMob></CarListNavbarMob>
    <img class="kv-mob" :src="img1" alt="" srcset="" id="mob0">
    <CardGroup></CardGroup>

    <!-- <img class="page-mob" :src="img2" alt="" srcset="" id="mob1">
    <img class="page-mob" :src="img3" alt="" srcset="" id="mob2">
    <img class="page-mob" :src="img4" alt="" srcset="" id="mob3">
    <img class="page-mob" :src="img5" alt="" srcset="" id="mob4"> -->

    <div class="mob-part-container">
      <img class="mob-fixed-bg" src="/assets/~/media/images/activity/2026summer/mob/bg.jpg" alt="background">
      <div class="mob-part-content">
        <div class="card-top part-container card-top-new" id="mob1">
          <img class="part-mob part-mob-new" style="height: calc(2964 / 1500 * 100vw);" :src="img2" alt="" srcset="" >
        </div>
        <div class="card-middle part-container card-top-new" id="mob2">
          <img class="part-mob part-mob-new" style="height: calc(2964 / 1500 * 100vw);" :src="img3" alt="" srcset="" >
        </div>
        <div class="card-middle part-container card-top-new" id="mob3">
          <img class="part-mob part-mob-new" style="height: calc(2964 / 1500 * 100vw);" :src="img4" alt="" srcset="" >
        </div>
        <div class="card-middle part-container card-top-new" id="mob4">
          <img class="part-mob part-mob-new" style="height: calc(3762 / 1500 * 100vw);" :src="img5" alt="" srcset="" >
        </div>
        <div class="card-middle part-container card-top-new" id="mob5" style="display: none">
          <img class="part-mob part-mob-new" style="height: calc(2966 / 1500 * 100vw);" :src="img6" alt="" srcset="" >
        </div>
        <div class="card-middle part-container card-top-new" id="mob6">
          <img class="part-mob part-mob-new" style="height: calc(3316 / 1500 * 100vw);" :src="img7" alt="" srcset="" >
        </div>
        <div class="card-small-container">
          <div class="card-middle part-container card-small card-small-top" id="mob7">
            <img class="part-mob"  :src="img8" alt="" srcset="" >
          </div>
          <div class="card-middle part-container card-small" id="mob8">
            <img class="part-mob"  :src="img9" alt="" srcset="" >
          </div>
          <div class="card-middle part-container card-small" id="mob9">
            <img class="part-mob"  :src="img10" alt="" srcset="" >
          </div>
          <div class="card-bottom part-container card-small card-small-bottom" id="mob10">
            <img class="part-mob"  :src="img11" alt="" srcset="" >
          </div>
        </div>
      </div>
    </div>
    <div class="my-form-box" @click.stop v-show="!loading" id="page5">
      <div class="form-container">
        <MyForm :clientPosition="clientPosition" @close="close" ></MyForm>
      </div>
    </div>

    <div v-if="isPortrait" class="yy-box" style="position: fixed;bottom:  50px;z-index: 200;">
        <!-- <img width="100" height="100" :src="arrow" alt="" srcset=""> -->
        <div class="yy-box-btn" id="book-button" >
          <button v-show="showTopBtn" ref="bookRef" @click="gotoBlock(5)" code-stm="event, PAGEURL, 点击预约品鉴">预约品鉴</button>
        </div>
      </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { isPortraitFun, getUrlKey, isAndroid } from "@/utils/utils.js";
import Firstpage from "./Firstpage.vue";
import CarListNavbarMob from "./CarListNavbarMob";
import CardGroup from "@/components/CardGroup";
import MyForm from "./My-Form.vue";
import $ from 'jquery'
import mShare from "@/utils/mShare";
// import myBMap from "@/utils/myBMap";
export default {
  components: { Firstpage, MyForm,CarListNavbarMob,CardGroup },
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
      minip2: false,
      loading: true,
      showLz: false,
      img1: '/assets/~/media/images/activity/2026summer/mob/kv.jpg',
      img2: '/assets/~/media/images/activity/2026summer/mob/1.jpg',
      img3: '/assets/~/media/images/activity/2026summer/mob/2.jpg',
      img4: '/assets/~/media/images/activity/2026summer/mob/3.jpg',
      img5: '/assets/~/media/images/activity/2026summer/mob/4.jpg',
      img6: '/assets/~/media/images/activity/2026summer/mob/5.png',
      img7: '/assets/~/media/images/activity/2026summer/mob/6.jpg',
      img8: '/assets/~/media/images/activity/2026summer/mob/7.png',
      img9: '/assets/~/media/images/activity/2026summer/mob/8.png',
      img10: '/assets/~/media/images/activity/2026summer/mob/9.png',
      img11: '/assets/~/media/images/activity/2026summer/mob/10.png',
      point: null,
      isAndroid: isAndroid(),
      // showTopBtn: false,

      isAnimating: false,
      formInline: {},
      alldata: null,
      carAlldata: null,
      cascadingCities: [],
      cascadingDealers: [],
      showTopBtn: true,
      page5Height:200,
      page5Top:100,
    };
  },
  props: {
    clientPosition: {
      type: Object,
      default: null
    }
  },
  computed: {
    swiperBoxHeight() {
      const imgHeight = 1.3 * window.innerWidth
      // console.log(imgHeight + 270 < window.innerHeight);
      if (imgHeight + 270 < window.innerHeight) {
        return (window.innerHeight - 270) + "px"
      } else {
        return imgHeight + "px"
      }
    }
  },

  mounted: function () {

    if (getUrlKey("minip") && getUrlKey("minip") == 2) {
      this.minip2 = true;
    }

    setTimeout(() => {
      this.loading = false
    }, 1000);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.updateIsPortrait);
    window.addEventListener('orientationchange', this.updateIsPortrait);
    this.page5Height = document.getElementById("page5").offsetHeight
    this.page5Top= document.getElementById("page5").offsetTop

    //到达表单
    var that = this
    var formDone = false
    window.addEventListener('scroll', function() {
      if(that.isPortrait){
        var scrollTop = (window.scrollY || document.documentElement.scrollTop);
        if (!(scrollTop < that.page5Top - that.page5Height + 450) && !(scrollTop > that.page5Top + 100) && !formDone) {
          console.log('到达表单');
          formDone = true;
          _paq.push(['trackEvent', '滚动事件', (window.location.href).replace(/\<br\>/ig, ''), '到达表单']);
        }
      }
    })

    var nowName=''
    var doneArray = []
    window.addEventListener('scroll', function() {
      if(that.isPortrait){
        var scrollTop = (window.scrollY || document.documentElement.scrollTop);

        var elements = [];
        var names = ['ev5', 'ev6', '2025款 狮铂拓界', '全新赛图斯', '智跑', '2026款 奕跑', '索奈', '2026款 嘉华', 'K3', 'K5'];

        for (var i = 1; i <= 10; i++) {
            var element = document.getElementById('mob' + i);
            var height = element.offsetHeight;
            var top = element.getBoundingClientRect().top + window.scrollY;

            elements.push({ element, height, top });
        }

        var newName = '';

        elements.forEach(function(item, index) {
            if (scrollTop > item.top - 100 && scrollTop < item.top + item.height) {
                newName = names[index];
            }
        });

        if(newName !== nowName && doneArray.indexOf(newName)===-1 && newName && newName!==''){
          console.log(newName);
            doneArray.push(newName)
            _paq.push(['trackEvent', '滚动事件', (window.location.href).replace(/\<br\>/ig, ''), newName]);
            nowName=newName
        }
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateIsPortrait);
    window.removeEventListener('orientationchange', this.updateIsPortrait);
  },
  methods: {
    updateIsPortrait() {
      this.isPortrait = isPortraitFun();
    },
    gotoBlock(e) {
    // console.log(e);
    // const el = this.$refs[`pc-block${e}`];
    var _that = this
    if (!this.isPortrait) {
      if (!this.isAnimating) {
        this.isAnimating = true;
        // 在动画结束后将 isAnimating 设置为 false，以便下次点击重新触发动画
        setTimeout(() => {
          this.isAnimating = false;
        }, 1000); // 假设动画持续 3 秒钟
      }
    } else {
      this.page5Height = document.getElementById("page5").offsetHeight
      this.page5Top= document.getElementById("page5").offsetTop
      var top =  this.page5Top;
      //页面滚动到top距离
      window.scrollTo({
        top: top - 20,
      });
      _that.showTopBtn = false
    }
  },
    goTop(){
      $('html,body').animate({scrollTop:0},0);
    },
    goBottom(e){
      // $('html,body').animate({scrollTop:document.body.scrollHeight},0);

      // console.log(e);
      // const el = this.$refs[`pc-block${e}`];
      // el.scrollIntoView()
      // console.log(e);
      // if (!this.isPortrait) {
      //   if (!this.isAnimating) {
      //     this.isAnimating = true;
      //     // 在动画结束后将 isAnimating 设置为 false，以便下次点击重新触发动画
      //     setTimeout(() => {
      //       this.isAnimating = false;
      //     }, 500);
      //   }
      // } else {
        const el = this.$refs[`pc-block${e}`];
        const headerHeight = 60; // 替换为您的固定头部的实际高度
        el.scrollIntoView();
        window.scrollBy(0, -headerHeight); // 减去固定头部的高度

    },
    // 监听页面滚动事件
    handleScroll() {
      // const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // this.showTopBtn = scrollTop > 0;
      this.page5Height = document.getElementById("page5").offsetHeight
      this.page5Top= document.getElementById("page5").offsetTop
      const scrollTop = (window.scrollY || document.documentElement.scrollTop);
      this.showTopBtn = (scrollTop < this.page5Top - this.page5Height + 50) || (scrollTop > this.page5Top + 500);
    },
    smoothScroll(event) {
      event.preventDefault();

      const targetId = event.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offsetTop = targetElement.offsetTop;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    },
    liuzi() {
      this.showLz = true
    },
    close() {
      this.showLz = false
    },

    //新增分享方法 start
    shareToWeibo(){//分享微博
      this.closePopup()
      //url不能带#
      const weiboShareUrl = `http://service.weibo.com/share/share.php?title=${document.title}&pic=https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg&url=${window.location.href}`;
      window.open(weiboShareUrl);
    },
    shareCopy(){//复制
      if(document.execCommand("Copy")){
        try {
          var txtEl = document.createElement('textarea');
          txtEl.value = window.location.href;
          document.body.appendChild(txtEl);
          txtEl.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          txtEl.remove();

          this.closePopup()
          const popup = document.getElementById('popup');
          setTimeout(function() {
              popup.style.display = 'flex';
              setTimeout(function() {
                  popup.style.display = 'none';
              }, 1000);
          }, 0);
        } catch(err) {
          // 复制失败
          console.log(err);
        }
      }else{
        navigator.clipboard.writeText(window.location.href).then(() => {
          this.closePopup()
          const popup = document.getElementById('popup');
          setTimeout(function() {
              popup.style.display = 'flex';
              setTimeout(function() {
                  popup.style.display = 'none';
              }, 1000);
          }, 0);
        }).catch((err) => {
            console.log(err);
        });
      }
    },
    //关闭弹窗
    closePopup(){
      var isShow = document.getElementById("popup-mob-share");
      isShow.style.display = "none";
      var isShow1 = document.getElementById("qr-popup-mob-share");//关闭二维码
      isShow1.style.display = "none";
    },
    sharePopup(){//弹出分享弹窗
      var isShow = document.getElementById("popup-mob-share");
      if(isShow.style.display !== "flex"){
        isShow.style.display = "flex";
      }else{
        isShow.style.display = "none";
        var isShow1 = document.getElementById("qr-popup-mob-share");//关闭二维码
        isShow1.style.display = "none";
      }
    },
    //微信分享
    shareWechat(){
      var UA = navigator.appVersion;
      var uc = UA.split('UCBrowser/').length > 1 ? 1 : 0;
      var qq = UA.split('MQQBrowser/').length > 1 ? 2 : 0;
      var wx = /micromessenger/i.test(UA);
      if(uc || (qq && !wx)){
        this.closePopup()
        var mshare = new mShare({
          title: document.title,
          url: window.location.href,
          desc: '',
          img: 'https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg'
        });
        setTimeout(function(){
          mshare.init(2);
        },800)
      }else{
        var isShow = document.getElementById("qr-popup-mob-share");
        if(isShow.style.display !== "flex"){
          isShow.style.display = "flex";
        }else{
          isShow.style.display = "none";
        }
      }
    }
    //end
  },
};
</script>

<style lang="scss" scoped>
.firstpage {
  position: relative;
}

.kv-mob {
  width: 100vw;
  height:  calc(4324 / 1500 * 100vw);
  // height:  100vh;
  object-fit: cover; /* 图片自适应裁切 */
  object-position: center;
}
.page-mob {
  width: 100vw;
  height:  100vh;
  object-fit: cover; /* 图片自适应裁切 */
  object-position: center;
}
.card-bottom {
  // padding-bottom: calc(156 / 1125 * 100vw);
  // padding-top: calc(70 / 1125 * 100vw);
}
.card-middle{
  // padding-bottom: calc(70 / 1125 * 100vw);
  // padding-top: calc(70 / 1125 * 100vw);
}
.card-top{
  // padding-bottom: calc(70 / 1125 * 100vw);
  // padding-top: calc(140 / 1125 * 100vw);
}
.card-top-new{
  // padding-bottom: 0 !important;
  // padding-top: 0 !important;
  // height: calc((1132 + 250 + 43) / 1125 * 100vw);
}
.card-small-container {
  background-image:  url('https://uat.kia.cn/assets/~/media/images/activity/2026summer/mob/bg.jpg');
  background-size: cover;
  padding-top: calc(62 / 750 * 100vw);
}
.card-small {
  padding-top: calc(50 / 750 * 100vw);
  padding-bottom: calc(50 / 750 * 100vw);
} 
.card-small-top {
  padding-top: calc(100 / 750 * 100vw);
}
.card-small-bottom {
  padding-bottom: calc(341 / 750 * 100vw);
}

.part-container{
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: #5c718a;
}
.part-mob {
  width:  calc(1340 / 1500 * 100vw);
  height: calc(1617 / 1500 * 100vw);
}
.part-mob-new {
  // height:  calc(1132 / 1125 * 100vw);
  width: 100vw;
  // width: calc(1017 / 1125 * 100vw);
}
.mob-part-container {
  position: relative;
  display: grid;
  width: 100%;
  background-color: #f0ede5;
}
.mob-part-content {
  grid-area: 1 / 1;
  position: relative;
  z-index: 1;
}
.mob-fixed-bg {
  grid-area: 1 / 1;
  position: sticky;
  top: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  object-position: bottom center;
  z-index: -1;
  align-self: start;
}
.bg {
  width: 100vw;
  height:  calc(2433 / 1125 * 100vw);
  margin-bottom: -1px;
}
.btn-box {
    width: calc(105 / 375 * 100vw);
    height: calc(40 / 375 * 100vw);
    position: absolute;
    left: 11.3vw;
    top: 30vw!important;
    z-index: 10;
    /* justify-content: flex-end; */
    /* .text {
      width:100%;
      height:auto;
      opacity: 0;
      transition: all 0.3s linear;
      &-show {
        opacity: 1;
      }
    } */
    .btn-go {
      border: 1px solid #fff;
      width: calc(105 / 375 * 100vw);
      height: calc(40 / 375 * 100vw);
      // opacity: 0;
      transition: all 0.3s linear;
      background: rgba(0,0,0,0);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(12 / 375 * 100vw);
      color: #fff;
      cursor: pointer;
      &-show {
        opacity: 1;
      }
      /* &:hover {
        color: #bb152b;
      } */
    }
  }
.firstpage {
  // background-color: #e8e0d4;
  position: relative;
  // height: 100%;
  // padding-bottom: 230px;
  width: 100%;
  overflow: visible;
  user-select: none;
  .rightBox{
    position: fixed;
    right: 10px;
    bottom: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999;
    img{
      width: calc(80 / 750 * 100vw);
      height: calc(80 / 750 * 100vw);
      &:first-child{

        border: 1px solid #ccc;
        border-radius: 6px;
      }
      &:last-child{
        margin-top: calc(19 / 750 * 100vw);
      }
    }
  }

  // img {
  //   width: 100%;
  //   height: 100%;
  //   object-fit: cover;
  //   margin-bottom: -1px;
  // }

  object {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper-box {
    width: 100%;
    overflow: hidden;
  }

  .my-form-box {
    width: 100%;
    display: flex;
    align-items: flex-end;
    // position: fixed;
    bottom: 0;
    border-radius: 10px 10px 0px 0px;
    z-index: 2;
    margin-top: -2px !important;
    .form-container {
      // position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      transition: transform 0.5s;
    }

    .slide-up {
      transform: translateY(390px);
    }

    // padding: 10px 16px 0;
  }

  .bgmask {
    background: #00000080;
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
}


.right-btn-box{
  display: flex;
  flex-direction: column;

  img{
    margin-top: 10px;
    width: 44px;
    height: 44px;
  }
}
@keyframes tbmove {
  from {
    margin-bottom: 10px;
  }

  to {
    margin-bottom: 20px;
  }
}

/* 新增 css start */
.popup { /* 复制成功*/
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: 120px;
    background-color: #05141F;
    opacity: 0.8;
    border-radius: 10px;
    /* display: flex; */
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000000;
    font-size: 16px;
    color: #ffffff;
  }
  .popup img {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
  }

  /* mob分享弹窗 */
  .popup-mob-share { /* 复制成功*/
    position: fixed;
    left: 50%;
    // top: 50%;
    bottom: calc(0px + 40px);
    width: 70%;
    transform: translate(-50%, -50%);
    background-color: #05141F;
    opacity: 0.9;
    border-radius: 10px;
    /* display: flex; */
    display: none;
    justify-content: space-between;
    align-items: center;
    z-index: 15;
    font-size: 16px;
    padding: 40px 30px 30px 30px;
  }
  .popup-mob-share .popup-mob-share-img {
    width: 50px;
    height: 65px;
    margin-bottom: 5px;
  }
  .qr-popup-mob-share{
    width: 120px;
    height: 120px;
    border-radius: 10px;
    background-color: #ffffff;
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -100px;
    right: calc(100% - 115px);
    transition: all .5s;
  }
  .qr-popup-mob-share::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: -5px; /* 使三角形垂直居中 */
    border-width: 6px;
    border-style: solid;
    border-color: #f9f9f9 transparent transparent transparent;
}
.qr-popup-mob-share .qr-code-wx {
      width: 91px;
      height: 91px;
      /* margin-bottom: 10px; */
  }

  .my-button {
    background: url('https://www.kia.cn/assets/~/media/images/dyk/index/footer/guanbi.png') no-repeat;
    background-size: cover;
    right:-10px;
    top:-10px;
    width:24px;
    height:24px;
    position:absolute;
  }
  .a-share-wx:hover .qr-code-box-wx {
    display: flex;
  }
  .qr-code-box-wx {
    width: 120px;
    height: 120px;
    border-radius: 10px;
    background-color: #ffffff;
    /* display: flex; */
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 168px;
    transition: all .5s;
  }
  .qr-code-box-wx::after {
    content: "";
    position: absolute;
    top: 40px;
    right: -10px; /* 调整三角形位置 */
    margin-top: -5px; /* 使三角形垂直居中 */
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9; /* 通过调整颜色来隐藏或显示三角形 */
}

  .qr-code-box-wx .qr-code-wx {
      width: 91px;
      height: 91px;
      /* margin-bottom: 10px; */
  }

  .qr-code-box-wx .text-wx {
      font-size: 12px;
      color: #05141F;
      line-height: 16px;
      width: 100px;
      text-align: center;
  }
 @media (min-width: 768px) {
  .btn-share-pc {
      display: block;
  }
  .btn-share-mob {
      display: none;
  }

}
@media (max-width: 768px) {
  .btn-share-mob{
    background: url('https://www.kia.cn/assets/~/media/images/dyk/index/footer/share-threepoint.png') no-repeat;
    background-size: 100%;
    width: calc(80 / 750 * 100vw);
    height: calc(80 / 750 * 100vw);
    cursor: pointer;
    overflow: visible;
  }
  .btn-share-mob:hover {
    overflow: visible;
  }
  .btn-share-pc {
      display: none;
  }

  .btn-share-mob {
      display: block;
  }
  .dropdown-content-mob {
    border-radius: 10px;
    min-width: 140px;
    background-color: #ffffff;
    /* display: flex; */
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -80px;
    right: 43px;
    transition: all .5s;
    padding: 15px 0;
  }
  .dropdown-content-mob::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -10px; /* 调整三角形位置 */
    margin-top: -5px; /* 使三角形垂直居中 */
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9; /* 通过调整颜色来隐藏或显示三角形 */
}
  .dropdown-item-mob {
    min-width: 160px;
    font-size: 16px;
    font-weight: 400;
      display: flex;
      align-items: center;
      padding: 15px 25px 15px 25px;
  }
  .dropdown-item-text-mob {
    padding-left: 10px;
  }
}
  /* 新增 css end */
  .yy-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  z-index: 1000;

  img {
    width: 24px;
    margin-bottom: 20px;
    animation: tbmove 0.7s infinite;
    // height: ;
  }

  &-btn {
    width: 80%;

    button {
      width: 100%;
      height: 43px;
      // width: calc(978 / 1125 * 100vw);
      // height: calc(135 / 1125 * 100vw);
      border-radius: 24px;
      background-color: #000000;
      color: #fff;
      border: 1px solid #FFFFFF;
      // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
    }
  }
}
</style>
